import PropTypes from 'prop-types';
import { createContext, useReducer } from 'react';
import { getDomain } from '../services/Utils';

var redirectWhiteList = [
  "cure.com",
  "twitter.com",
  "facebook.com",
  "youtube.com",
  "instagram.com",
  "linkedin.com"
]
export const UserContext = createContext()

const initialState = {
  emailAddress: null
}

export const reducer = (state, action) => {
  switch (action.type) {
    default:
      return state
  }
}

export const UserContextProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState)

  var url = new URL(window.location)
  for (const value of url.searchParams.values()) {
    if (!isSearchParamsValid(value)) {
      var redirectURL = `${getDomain()}/404`
      window.location.replace(redirectURL)
      return
    }
  }
  return <UserContext.Provider value={[state, dispatch]}>{props.children}</UserContext.Provider>
}

const isSearchParamsValid = (value) => {
  // Regex: optional http(s):// and www., domain/subdomain(s), 2+ char TLD (letters or numbers), optional path
  const urlRegex = /^(?:(?:https?:\/\/)?(?:www\.)?)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,}(?:\/\S*)?$/;

  if (urlRegex.test(value)) {
    let host = "";
    try {
      // Try parsing directly
      host = new URL(value).host;
    } catch (error) {
      // Prepend http:// if no scheme is present
      let testValue = value.trim();
      if (!/^https?:\/\//i.test(testValue)) {
        testValue = "http://" + testValue;
      }
      host = new URL(testValue).host;
    }

    // Extract domain + TLD
    const parts = host.split(".");
    let domain = host;

    if (parts.length >= 2) {
      const publicSuffixes = ["co.uk", "org.uk", "gov.uk", "ac.uk", "com.au", "net.au", "gov.au"]; 
      const lastTwo = parts.slice(-2).join(".");
      const lastThree = parts.slice(-3).join(".");

      if (publicSuffixes.includes(lastTwo) || publicSuffixes.includes(lastThree)) {
        // Handle multi-part TLDs
        domain = parts.slice(-3).join(".");
      } else {
        domain = lastTwo;
      }
    }

    return redirectWhiteList.includes(domain.toLowerCase());
  }

  // If value is not a URL (doesn’t match regex), consider it valid
  return true;
};



UserContextProvider.propTypes = {
  children: PropTypes.object
}
